/// <reference types="./ServerPublishedClient.d.ts" />
import { createBasePublishedDossierClient, ok, PublishedDossierClientOperationName, } from '@dossierhq/core';
import { publishedGetEntity } from './published-entity/publishedGetEntity.js';
import { publishedGetEntityList } from './published-entity/publishedGetEntityList.js';
import { publishedGetTotalCount } from './published-entity/publishedGetTotalCount.js';
import { publishedSampleEntities } from './published-entity/publishedSampleEntities.js';
import { publishedSearchEntities } from './published-entity/publishedSearchEntities.js';
import { assertExhaustive } from './utils/AssertUtils.js';
export function createServerPublishedClient({ context, authorizationAdapter, databaseAdapter, serverImpl, middleware, }) {
    async function terminatingMiddleware(context, operation) {
        switch (operation.name) {
            case PublishedDossierClientOperationName.getEntity: {
                const { args: [reference], resolve, } = operation;
                resolve(await publishedGetEntity(serverImpl.getAdminSchema(), authorizationAdapter, databaseAdapter, context, reference));
                break;
            }
            case PublishedDossierClientOperationName.getEntityList: {
                const { args: [references], resolve, } = operation;
                resolve(await publishedGetEntityList(serverImpl.getAdminSchema(), authorizationAdapter, databaseAdapter, context, references));
                break;
            }
            case PublishedDossierClientOperationName.getSchemaSpecification: {
                const { resolve } = operation;
                const schema = serverImpl.getPublishedSchema();
                resolve(ok(schema.spec));
                break;
            }
            case PublishedDossierClientOperationName.getEntitiesTotalCount: {
                const { args: [query], resolve, } = operation;
                resolve(await publishedGetTotalCount(serverImpl.getPublishedSchema(), authorizationAdapter, databaseAdapter, context, query));
                break;
            }
            case PublishedDossierClientOperationName.getEntitiesSample: {
                const { args: [query, options], resolve, } = operation;
                resolve(await publishedSampleEntities(serverImpl.getAdminSchema(), serverImpl.getPublishedSchema(), authorizationAdapter, databaseAdapter, context, query, options));
                break;
            }
            case PublishedDossierClientOperationName.getEntities: {
                const { args: [query, paging], resolve, } = operation;
                resolve(await publishedSearchEntities(serverImpl.getAdminSchema(), serverImpl.getPublishedSchema(), authorizationAdapter, databaseAdapter, context, query, paging));
                break;
            }
            default:
                assertExhaustive(operation.name);
        }
    }
    return createBasePublishedDossierClient({
        context,
        pipeline: [...middleware, terminatingMiddleware],
    });
}
//# sourceMappingURL=ServerPublishedClient.js.map